import axiosCall from './interceptor';
import URL from '../helper';
import {
  getAllContractsMock,
  getContractMock,
  createContractMock,
  updateContractMock,
  deleteContractMock
} from '../mockData/contractsMockData';

// Flag to switch between mock and real API
// Set to true to use mock data, false to use real API
const USE_MOCK_DATA = false;

export const getAllContracts = async () => {
  if (USE_MOCK_DATA) {
    return getAllContractsMock();
  }
  
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getContract = async (id) => {
  if (USE_MOCK_DATA) {
    return getContractMock(id);
  }
  
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts/${id}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const createContract = async (payload) => {
  if (USE_MOCK_DATA) {
    return createContractMock(payload);
  }
  
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};

export const updateContract = async (id, payload) => {
  if (USE_MOCK_DATA) {
    return updateContractMock(id, payload);
  }
  
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts/${id}`;
  const response = await axiosCall('put', url, { id, ...payload });
  return response.data;
};

export const deleteContract = async (id) => {
  if (USE_MOCK_DATA) {
    return deleteContractMock(id);
  }
  
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts/${id}`;
  const response = await axiosCall('delete', url);
  return response.data;
};

